import {StoreExt} from '@utils/reactExt'
import {observable, action, runInAction} from 'mobx'
import {deepClone} from '@src/utils';
import {userStore} from '@store/userStore';

class BlindBoxStore extends StoreExt {
    @observable showModal: boolean = false;
    @observable modalBg: string = '';
    @observable actResult: any = {};
    @observable actDetail: any = {};
    @observable remainingTimes: number;
    @observable blindBoxGoodsDetail: any = {};
    @observable showSuccessModal: boolean = false;
    @observable openingBlindBoxContent: any = {}; // 盲盒拆开的内容
    @action
    setObservableData = (key: string, value: any) => {
        this[key] = value
    };
    @action
    getBlindBoxActDetail = async () => {
        try {
            const res = await this.api.queryActivityDetail({});
            res.laoActivity.descrInfoList = res.laoActivity.descr.split('\n');
            runInAction(() => {
                this.actResult = res;
                this.actDetail = res.laoActivity;
                this.remainingTimes = res.remainingTimes
            })
        } catch (e) {
        }
    };
    @action
    getBlindBoxGoodsDetail = async () => {
        this.$toast.loading('加载中');
        try {
            const res = await this.api.queryBoxPlan({});
            runInAction(() => {
                this.blindBoxGoodsDetail = res[0]
            })
        } catch (e) {
        }
    };
    // 点击购买
    @action
    doOrder = async (payway: string, simId: string) => {
        this.$toast.loading('订单生成中');
        try {
            const res = await this.api.gobuyPlan({
                simId: simId,
                goodsReleaseId: this.blindBoxGoodsDetail.goodsReleaseId,
                paymentType: payway,
                activityId: this.actDetail.activityId
            });
            this.handlePay(res, payway)
        } catch (e) {
        }
    };
    // 支付
    handlePay = async (orderId: string, payway: string) => {
        try {
            const res = await this.api.payingPlan({
                orderId: orderId,
                goodsName: this.blindBoxGoodsDetail.goodsReleaseName,
                paymentType: payway
            });
            if (payway === '1') {
                const url = deepClone(userStore.payConfig) || '';
                const eUrl = encodeURIComponent(url);
                window.location.href = res.resinfo.concat(`&redirect_url=${eUrl}`) // 跳转支付
            }
            if (payway === '2') {
                const payFormDom = document.getElementById('pay_form');
                // 查询是否有支付表单存在，如果存在，删除之前的表单节点
                if (payFormDom) {
                    payFormDom.innerHTML = '';
                    payFormDom.innerHTML = res.resinfo
                } else {
                    const div = document.createElement('div');
                    div.setAttribute('id', 'pay_form');
                    /* 此处form就是后台返回接收到的数据 */
                    div.innerHTML = res.resinfo;
                    document.body.appendChild(div)
                }
                document.forms[0].submit()
            }
        } catch (e) {
        }
    };
    /**
     * 支付宝回调后，根据orderId查询盲盒拆开的内容
     * @param {string} orderId
     * @returns {Promise<void>}
     */
    @action
    getBlindBoxOpenDetail = async (orderId: string) => {
        try {
            const res = await this.api.queryBlindBoxDetail({orderId});
            runInAction(() => {
                this.setObservableData('showSuccessModal', true);
                this.setObservableData('openingBlindBoxContent', res);
            })
        } catch (e) {
        }
    }
}

const blindBoxStore = new BlindBoxStore();
export {blindBoxStore, BlindBoxStore}
